import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const MailRead: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3438 6.79163V13.5885C14.3438 13.8289 14.2483 14.0594 14.0783 14.2293C13.9084 14.3993 13.6779 14.4948 13.4375 14.4948H2.5625C2.32215 14.4948 2.09164 14.3993 1.92168 14.2293C1.75173 14.0594 1.65625 13.8289 1.65625 13.5885V6.79163L6.88048 10.9356C7.19977 11.1864 7.59401 11.3227 8 11.3227C8.40599 11.3227 8.80023 11.1864 9.11952 10.9356L14.3438 6.79163Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3438 6.79177L9.32494 2.38135C9.15536 2.19969 8.95023 2.05484 8.7223 1.95581C8.49437 1.85677 8.24851 1.80566 8 1.80566C7.75149 1.80566 7.50563 1.85677 7.2777 1.95581C7.04977 2.05484 6.84464 2.19969 6.67506 2.38135L1.65625 6.79177"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
